import React from 'react'
import { Link as LinkBase } from 'react-router-dom'
import { Card as CardBase, Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const CardCustom = styled(CardBase)`
  &.MuiPaper-root {
    background-color: ${props => props.theme.palette.custom.zumthor};

    box-shadow: 0 4px 10px rgba(118, 138, 162, 0.2);
    cursor: pointer;
    max-width: 100%;
    padding: 4px 6px;
    justify-content: center;
    display: flex;
  }
`
export const Root = styled('div')`
  background-size: cover;
  background-color: ${props => props.theme.palette.charts.gray};
  background-image: url('/assets/images/emtParticipation.svg');
  background-position: center;
  width: 100%;
`
export const Content = styled(({ margin, padding, ...props }) => <ContainerBase container {...props} />)`
  &.MuiContainer-root {
    padding: 64px 32px;
  }
  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding:  38px 40px;
    }
`
export const DialogLink = styled(({ active, width, ...props }) => <LinkBase {...props} />)`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  text-decoration: none;
  font-weight: bold;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`
export const ExclamationIcon = styled('div')`
  height: 12px;
  padding: 1px;
  outline: none;
  width: 12px;

  &::before {
    color: ${props => props.theme.palette.brand.white};
    content: '¡';
    display: block;
    font-size: 10px;
    line-height: 9px;
    margin-left: 0.5px;
    text-align: center;
    width: 100%;
  }
`
export const GridContainer = styled(({ margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`
export const Info = styled(({ justifyContent, ...props }) => <div {...props} />)`
  align-items: center;
  color: ${props => props.theme.palette.brand.black1};
  cursor: initial;
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  padding: 0 0 0 4px;
  ${props => props.theme.breakpoints.down('sm')} {
    justify-content: center;
  }
`
export const InfoCircle = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.charts.navyBlue};
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin: 0 0 0 6px;
`
export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 34px;
  line-height: 38px;
  letter-spacing: 0.2px;
  margin: 0;
  padding: 0 0 28px;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin: 0;
  padding: 0 0 28px;
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 14px;
  text-decoration: underline;
`
export const Strong = styled('strong')``

export const InfoLabel = styled('div')`
  display: inline-block;
  zoom: 1;
  margin: ${props => props.margin};
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-style: italic;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  white-space: pre-line;
`
